import { useQuery } from '@tanstack/react-query';
import { modulesQueries } from 'src/modules/modules/queries';
export function useGetModuleById(moduleId) {
    return useQuery(modulesQueries.byId(moduleId));
}
